import DetailTitle from "@/components/DetailTitle";
import { Row, Col } from "antd";
import { GlobalOutlined } from '@ant-design/icons';
import styles from "./index.module.scss";
import React from "react";
import Feature from 'ol/Feature';
import Map from 'ol/Map';
import Point from 'ol/geom/Point';
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import XYZ from 'ol/source/XYZ'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Icon, Style } from 'ol/style';
import 'ol/ol.css';
import 'ol-layerswitcher/dist/ol-layerswitcher.css';
import LayerSwitcher from 'ol-layerswitcher';
import { useEffect, useRef } from "react";
import intl from "react-intl-universal";

const SpatialMap = ({ coordInfo }) => {
	// openlayers将会渲染进这个div
	const mapRef = useRef()
	const projection = 'EPSG:4326'
	const center = [coordInfo.longitude, coordInfo.latitude]; //地图中心位置  武大 -- 114.
	let map = null; //地图全局变量
	const tk = '8c471ad83d563e443d9a630de25f23a0'

	const addMap = () => {
		const iconFeature = new Feature({
			geometry: new Point(center),
			name: 'Null Island',
			population: 4000,
			rainfall: 500,
		});

		const iconStyle = new Style({
			image: new Icon({
				anchor: [0.5, 46],
				anchorXUnits: 'fraction',
				anchorYUnits: 'pixels',
				src: '/assets/location.png',
			}),
		});

		iconFeature.setStyle(iconStyle);

		const iconVecLayer = new VectorLayer({
			source: new VectorSource({
				features: [iconFeature],
			})
		})
		map = new Map({
			view: new View({
				center: (center[0] && center[1]) ? center : [0, 0], //地图中心位置  武大 -- 114.36, 30.54
				projection,//地图投影方式
				zoom: (center[0] && center[1]) ? 10 : 1,//地图初始层级
				maxZoom: 15,
				minZoom: 1
			}),
			controls: [],
			layers: [
				new TileLayer({
					title: "天地图矢量图层",
					source: new XYZ({
						url: `https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_c&tk=${tk}&x={x}&y={y}&l={z}`,
						projection,
					}),
				}),
				new TileLayer({
					title: "天地图矢量图层注记",
					source: new XYZ({
						url: `https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_c&tk=${tk}&x={x}&y={y}&l={z}`,
						projection,
					}),
				}),
				new TileLayer({
					title: "天地图影像图层",
					source: new XYZ({
						url: `https://t{0-7}.tianditu.gov.cn/DataServer?T=img_c&tk=${tk}&x={x}&y={y}&l={z}`,
						projection,
					}),
					visible: false,
				}),
			],
			target: mapRef.current
		});

		if (center[0] && center[1]) {
			map.addLayer(iconVecLayer);
		}

		const layerSwitcher = new LayerSwitcher({
			reverse: true,
			groupSelectStyle: 'group'
		});
		map.addControl(layerSwitcher);
	}

	useEffect(() => {
		addMap();
		// 卸载组件时清除地图实例
		return () => {
			if (map) {
				map.setTarget(null); // 解除地图绑定
				map.dispose(); // 销毁地图
			}
		};
	}, [])
	return (
		<div>
			<DetailTitle title="Spatial & Temporal" />
			<Row gutter={40}>
				<Col span={8}>
					<div className={styles.leftBox}>
						<div>
							<GlobalOutlined style={{ marginRight: "5px" }} />
							{intl.get("Share.Coordinate System/Geographic Projection")}
						</div>
						<div>WGS 84 EPSG:4326</div>
						<div>{intl.get("Share.Decimal degrees")}</div>
						<div>{intl.get("Share.Place/Area Name")}</div>
						<div>{coordInfo.areaName}</div>
						<div><span>{intl.get("Share.Longitude")}：</span>{coordInfo.longitude}°</div>
						<div><span>{intl.get("Share.Latitude")}：</span>{coordInfo.latitude}°</div>
						<div><span>{intl.get("Share.Temporal")}</span>{coordInfo.startDate ? (coordInfo.startDate + ' ~ ' + coordInfo.endDate) : ""}</div>
					</div>
				</Col>
				<Col span={16}>
					<div ref={mapRef} className={styles.mapBox}></div>
				</Col>
			</Row>
		</div>
	)
}
export default SpatialMap;
